var _excluded = ["height", "columns", "dataSource", "rowKey", "pagination", "loading", "defaultSort", "rowSelection", "expandable", "size", "onChange", "renderEmpty", "virtual", "showHeader", "updateScrollTop", "PaginationProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo, forwardRef, useEffect, useRef, useImperativeHandle } from 'react';
import { styled } from '@mui/material';
import TableContext from "./context";
import Pagination from "../Pagination";
import NTable from "./NTable";
import VTable from "./VTable";
var TableWrap = styled('div', {
  name: 'MuiTableWrap',
  slot: 'Root'
})(function (_ref) {
  var ownerState = _ref.ownerState;
  return {
    height: ownerState === null || ownerState === void 0 ? void 0 : ownerState.height,
    maxHeight: ownerState === null || ownerState === void 0 ? void 0 : ownerState.maxHeight
  };
});
var InternalTable = function InternalTable(props, ref) {
  var height = props.height,
    columns = props.columns,
    dataSource = props.dataSource,
    _props$rowKey = props.rowKey,
    rowKey = _props$rowKey === void 0 ? 'key' : _props$rowKey,
    _props$pagination = props.pagination,
    paginationProps = _props$pagination === void 0 ? false : _props$pagination,
    loading = props.loading,
    defaultSort = props.defaultSort,
    rowSelection = props.rowSelection,
    expandable = props.expandable,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    onChange = props.onChange,
    renderEmpty = props.renderEmpty,
    _props$virtual = props.virtual,
    virtual = _props$virtual === void 0 ? 'auto' : _props$virtual,
    _props$showHeader = props.showHeader,
    showHeader = _props$showHeader === void 0 ? true : _props$showHeader,
    _props$updateScrollTo = props.updateScrollTop,
    updateScrollTop = _props$updateScrollTo === void 0 ? true : _props$updateScrollTo,
    PaginationProps = props.PaginationProps,
    other = _objectWithoutProperties(props, _excluded);
  if (virtual === true && height === void 0) {
    console.error('virtual table need height');
  }
  var isVirtual = useMemo(function () {
    if (virtual === true && height) {
      return true;
    }
    if (virtual === 'auto' && height && dataSource.length > 100) {
      return true;
    }
    return false;
  }, [virtual, height, dataSource]);
  var wrapRef = useRef(null);
  var tableHeight = useMemo(function () {
    return "calc(100% - ".concat(paginationProps && dataSource.length !== 0 ? '54px' : '0px', ")");
  }, [paginationProps]);
  var onPaginationChange = function onPaginationChange(page, pageSize) {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      current: page,
      pageSize: pageSize
    });
  };
  useEffect(function () {
    if (updateScrollTop) {
      var _wrapRef$current, _wrapRef$current$scro;
      (_wrapRef$current = wrapRef.current) === null || _wrapRef$current === void 0 ? void 0 : (_wrapRef$current$scro = _wrapRef$current.scrollTo) === null || _wrapRef$current$scro === void 0 ? void 0 : _wrapRef$current$scro.call(_wrapRef$current, {
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [dataSource, updateScrollTop]);
  var contextValue = {
    dataSource: dataSource,
    columns: columns,
    rowKey: rowKey,
    loading: loading,
    defaultSort: defaultSort,
    rowSelection: rowSelection,
    expandable: expandable,
    size: size,
    height: tableHeight,
    renderEmpty: renderEmpty,
    showHeader: showHeader,
    updateScrollTop: updateScrollTop
  };
  useImperativeHandle(ref, function () {
    return wrapRef.current;
  });
  return /*#__PURE__*/React.createElement(TableContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(TableWrap, _extends({}, other, {
    ownerState: {
      height: height
    }
  }), isVirtual ? /*#__PURE__*/React.createElement(VTable, {
    ref: wrapRef
  }) : /*#__PURE__*/React.createElement(NTable, {
    ref: wrapRef
  }), paginationProps && dataSource.length !== 0 && /*#__PURE__*/React.createElement(Pagination, _extends({
    onChange: onPaginationChange
  }, paginationProps, {
    sx: {
      pt: 2
    }
  }, PaginationProps))));
};
var Table = /*#__PURE__*/forwardRef(InternalTable);
export default Table;